<template>
    <div class="mt-n16">
        <v-main class="d-flex d-md-none">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="id" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 진행 예정</span> <span v-if="estimations.total > 0" class="headline">({{ estimations.total }})</span></h2>
                </v-col>
                <v-col cols="6">
                    <AddEstimationDialog style="float:right"></AddEstimationDialog>
                    <v-btn icon outlined class="mr-3 mt-n1 d-none d-md-flex" style="float:right" @click="getEstimations">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색하세요 :)"
                            outlined
                            dense
                            clearable
                            class="mr-3 mt-n1"
                            style="float:right;"
                            v-model="estimationSearchText"
                            @keydown.enter="getEstimations"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-simple-table class="mx-0 mt-5">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="pl-1 text-left" query-key="name" @click="getOrderedData">작성일</th>
                        <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">회원</th>
                        <th class="pl-0 text-left" query-key="category" @click="getOrderedData">제목</th>
                        <th class="pl-0 text-left" query-key="title" @click="getOrderedData">금액</th>
                        <th class="text-right">삭제</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="estimation in estimations.data" :key="estimation.id" dense>
                            <td class="pl-1 caption">{{ estimation.estimationDate }}</td>
                            <td><strong style="color: deeppink" class="'caption">{{ estimation.clientName }}</strong></td>
                            <td class="caption font-weight-medium">
                                <AddEstimationDialog :mode="'string'" 
                                v-bind:estimation-id="estimation.id" v-bind:display-string="estimation.title"></AddEstimationDialog>
                                <!-- {{ estimation.title }} -->
                            </td>
                            <td class="caption font-weight-medium">{{ estimation.finalPriceSummary }}</td>
                            <td>
                                <DeleteEstimationButton v-if="1 || pcFlag" :estimation-id="estimation.id"></DeleteEstimationButton>
                            </td>
                        </tr>

                        <tr v-if="estimations.length == 0">
                            <td colspan="5" class="no-data">
                                표시할 데이터가 없습니다.
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>

        <v-main class="d-none d-md-block">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="id" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 간편견적 내역</span> <span v-if="estimations.total > 0" class="headline">({{ estimations.total }})</span></h2>
                </v-col>
                <v-col cols="6">
                    <AddEstimationDialog style="float:right"></AddEstimationDialog>
                    <v-btn icon outlined class="mr-3 mt-n1" style="float:right" @click="getEstimations">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색어를 입력하세요"
                            outlined
                            dense
                            clearable
                            class="mr-3 mt-n1"
                            style="float:right;"
                            v-model="estimationSearchText"
                            @keydown.enter="getEstimations"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="pl-1 text-left" query-key="name" @click="getOrderedData">작성일</th>
                        <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">회원</th>
                        <th class="pl-0 text-left" query-key="category" @click="getOrderedData">제목</th>
                        <th class="pl-0 text-left" query-key="title" @click="getOrderedData">금액</th>
                        <th class="text-right">삭제</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="estimation in estimations.data" :key="estimation.id" dense>
                        <td class="pl-1 caption">{{ estimation.estimationDate }}</td>
                        <td><strong style="color: deeppink" class="'caption">{{ estimation.clientName }}</strong></td>
                        <td class="caption font-weight-medium">
                            <AddEstimationDialog :mode="'string'" 
                            v-bind:estimation-id="estimation.id" v-bind:display-string="estimation.title"></AddEstimationDialog>
                            <!-- {{ estimation.title }} -->
                        </td>
                        <td class="caption font-weight-medium">{{ estimation.finalPriceSummary }}</td>
                        <td>
                            <DeleteEstimationButton v-if="1 || pcFlag" :estimation-id="estimation.id"></DeleteEstimationButton>
                        </td>
                    </tr>

                    <tr v-if="estimations.length == 0">
                        <td colspan="9" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import AddEstimationDialog from '@/components/order/AddEstimationDialog'
import DeleteEstimationButton from "@/components/order/button/DeleteEstimationButton"

export default {
    name: 'EstimationRows',
    components: {
        AddEstimationDialog,
        DeleteEstimationButton
    },
    data () {
        return {
            orderConditionNow: "",
            estimationSearchText: this.searchText,
            estimations: [],
            totalPages: 1,
            page: 1,
            mobileFlag: false,
            pcFlag: false
        }
    },
    watch: {
        estimationSearchText: async function(newText) {
            const queryOptions = await this.$store.getters.getEstimateQueryOptions
            queryOptions.queryText = newText
            await this.$store.dispatch('setEstimationQueryOptions', queryOptions)

            if(newText == ''){
                await this.getEstimations()
            }
        },
        page: async function(newPage, oldPage) {

            if(newPage != oldPage){

                const queryOptions = await this.$store.getters.getEstimationQueryOptions
                queryOptions.page = newPage
                await this.$store.dispatch('setEstimationQueryOptions', queryOptions)
                await this.getEstimation()

            }

        }
    },
    methods: {
        async getEstimations() {
            await this.$store.dispatch('getEstimations')
            this.estimations = await this.$store.getters.getEstimations
            this.totalPages = this.estimations.lastPage
            if(this.page > this.totalPages){
                this.page = 1
            }
        },
        async getOrderedData(e) {

            e
            return false

            // const key = e.currentTarget.getAttribute('query-key')
            // const queryOptions = await this.$store.getters.getEstimateQueryOptions

            // queryOptions.prevKey = key

            // if(queryOptions.queryKey != key){
            //     queryOptions.queryKey = key
            //     queryOptions.queryOrder = 'desc'
            // }else if(queryOptions.queryKey == key){
            //     if(queryOptions.queryOrder == 'desc'){
            //         queryOptions.queryOrder = 'asc'
            //     }else{
            //         queryOptions.queryOrder = 'desc'
            //     }
            // }

            // this.getOrderConditionNow(key, queryOptions.queryOrder)

            // await this.$store.dispatch('setEstimationQueryOptions', queryOptions)
            // await this.getEstimations()

        },
        getOrderConditionNow(key, order) {

            //정렬 기준 표기
            if(key == 'id') {
                this.orderConditionNow = "입력시간"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'name') {
                this.orderConditionNow = "거래처"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'estimateDate') {
                this.orderConditionNow = "작성일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'dueDate') {
                this.orderConditionNow = "납품예정일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'category') {
                this.orderConditionNow = "품목"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'title') {
                this.orderConditionNow = "작업명"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'estimateStatus') {
                this.orderConditionNow = "진행상태"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'paymentStatus') {
                this.orderConditionNow = "결제상태"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }

        }
    },
    created: async function() {
        await this.getEstimations()
        setInterval(this.getEstimations, this.$store.getters.getCommonRefreshInterval)

        const queryOptions = await this.$store.getters.getEstimationQueryOptions
        this.page = queryOptions.page
        if (!this.estimationSearchText){
            queryOptions.queryText = ''
            await this.$store.dispatch('setEstimationQueryOptions', queryOptions)
        }

        this.getOrderConditionNow(queryOptions.queryKey, queryOptions.queryOrder)

        switch(this.$vuetify.breakpoint.name) {
            case 'xl':
            case 'lg':
            case 'md':
                this.mobileFlag = false
                this.pcFlag = true
                break
            case 'sm':
            case 'xs':
                this.mobileFlag = true
                this.pcFlag = false
                break
        }
    }
}
</script>

<style scoped>
    .no-data { text-align: center; background-color: aliceblue; }
    /*table, tr, td { padding: 0em }*/
    tr, td {
        padding: 2px !important;
    }
</style>